import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityModel } from '../../../models/entity.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { EntityService } from '../../../services/entity/entity.service';

@Component({
  selector: 'app-entities',
  templateUrl: './entity.component.html'
})
export class EntityComponent implements OnInit {

  private titles: DataTableField[];
  private customButtons: DataTableCustomButton[];
  modalTitle = '';
  labels = {};
  entities: Array<EntityModel>
  selectedEntity: EntityModel;
  show = {
    modal: false
  }
  newDataAvailable: boolean = false;

  constructor(
    public svc: EntityService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {
      this.translate.get([
        'common.entity_name',
        'common.entity_description'
      ]).subscribe((res) => {
        console.log(res);
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'name', label: res['common.entity_name'] },
          { id: 'description', label: res['common.entity_description'] },
        ];

        this.customButtons = []

      });
  }

  ngOnInit() {

    this.entities = [];

    this.svc.getList().subscribe(res=>{
      this.entities = res;
    });

    this.translate.get([
      'entityList.add_title',
      'entityList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['entityList.add_title'];
      this.labels['edit_title'] = res['entityList.edit_title'];
    });

    this.reloadList();
  }

  reloadList() {
    this.svc.getList().subscribe(res=>{
      this.entities = res;
      this.newDataAvailable = true;
    });
  }

  showAddOrEditDialog(data): void {    
    
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];

    if (data != null) {
      this.svc.get(data['id']).subscribe(res => {        
        this.selectedEntity = res;        
        this.show.modal = true;
      })
    }
    else{
      this.selectedEntity = new EntityModel();
      this.show.modal = true;
    }

  
   
    
    /*
    if (data != null) {
      this.svc.get(data['id']).subscribe(res => {        
        this.selectedEntity = res;
      })
    }
    else{
      this.selectedEntity = null;
    }
    */
    
  }

  delete (entry): void {
    this.svc.delete(entry.id).subscribe(() => {
      this.reloadList();
      this.show.modal = false;
    });
  }

  onAddElement(entry): void {
    this.svc.post(entry).subscribe(() => {
      this.srvDataTable.get('dt_entities').showDetail = false;
      this.selectedEntity = null;
      this.reloadList();
      this.show.modal = false;
    });
  }

  onUpdateElement(entry): void {
    this.svc.put(this.selectedEntity.id, entry).subscribe(() => {
        this.srvDataTable.get('dt_entities').showDetail = false;
        this.selectedEntity = null;
        this.reloadList();
        this.show.modal = false;
    })
  }

  closeAddDialog () {
    this.show.modal = false;
    this.selectedEntity = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/entity/entity.component.ts